import * as React from "react";
import { connect } from "react-redux";


const withAccountHOC = (WrapComponent: any) => {

    interface IHoc {
        initRef: Function;
        dispatch: Function;
    }

    class Hoc extends React.Component<IHoc, any> {
        constructor(props: IHoc) {
            super(props);
            this.state = {
                isLoading: false,
                error: ""
            }
        }

        setLoading = (bol: boolean) => {
            this.setState({
                isLoading: bol
            })
        }

        goWithAction = async (action: Function) => {
            try {
                this.setLoading(true);
                await this.props.dispatch(action)
            } catch (er) {
                this.setState({
                    error: er
                })
            }
            this.setLoading(false);
            return true;
        }

        render() {
            return (
                <WrapComponent
                    error={this.state.error}
                    goWithAction={this.goWithAction}
                    isLoading={this.state.isLoading}
                    {...this.props}
                />
            )
        }
    }

    return connect()(Hoc);
}

export default withAccountHOC;


// WEBPACK FOOTER //
// ./src/components/account/withAccountHOC.tsx